<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#service-map-container{
        position: absolute;
        top: 75px;
        left: 0px;
        right: 0px;
        bottom: 0px;

        div#service-map {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
        }

        div.service-info-window {
            div.service-name {
                display: block;
                text-align: center;
                color: $dark-color;
                font-family: 'Raleway', sans-serif;
            }

            div.service-address {
                display: block;
                text-align: center;
                margin-top: 5px;
                color: $grey;
                font-family: 'Raleway', sans-serif;

                span.street {
                    font-size: 14px;
                    display: block;
                }

                span.city {
                    font-size: 12px;
                }

                span.state {
                    font-size: 12px;
                }

                span.zip {
                    font-size: 12px;
                    display: block;
                }

                a {
                    color: $secondary-color;
                    font-weight: bold;
                }
            }
        }
    }

    a[href^="http://maps.google.com/maps"] {
        display: none !important
    }

    a[href^="https://maps.google.com/maps"] {
        display: none !important
    }

    .gmnoprint a, .gmnoprint span, .gm-style-cc {
        display: none;
    }
</style>

<template>
    <div id="service-map-container">
        <div id="service-map">

        </div>
    </div>
</template>

<script>
    import { ServiceTypeFilter } from '../../mixins/filters/ServiceTypeFilter.js';
    import { EventBus } from '../../event-bus.js';
    import Geocode from '../../api/geocode';

    export default {
        props: {
            'latitude': {
                type: Number,
                default: function() {
                    return 50.05
                }
            },
            'longitude': {
                type: Number,
                default: function() {
                    return 14.35
                }
            },
            'zoom': {
                type: Number,
                default: function() {
                    return 8
                }
            },
        },

        mixins: [
            ServiceTypeFilter
        ],

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            distance() {
                return this.$store.getters.getDistanceFilter;
            },

            services() {
                return this.$store.getters.getServices;
            },

            servicesLoadStatus() {
                return this.$store.getters.getServicesLoadStatus;
            },

            activeLocationFilter() {
                return this.$store.getters.getActiveLocationFilter;
            },

            previousLat() {
                return this.$store.getters.getLat;
            },

            previousLng() {
                return this.$store.getters.getLng;
            },

            previousZoom() {
                return this.$store.getters.getZoomLevel;
            },
        },

        watch: {
            '$route' (to, from) {
                if (to.name == 'services' && from.name == 'service') {
                    if (this.previousLat != 0.0 && this.previousLng != 0.0 && this.previousZoom != '') {
                        var latLng = new google.maps.LatLng(this.previousLat, this.previousLng);

                        this.$map.setZoom(this.previousZoom);
                        this.$map.panTo(latLng);
                    }
                }
            },

            /*
              Watches the services. When they are updated, clear the markers and build them
            */
            services() {
                if (this.services.length > 0) {
                    this.$foundSomething = true;
                } else {
                    this.$foundSomething = false;
                }

                if ((this.services.length == 0 && this.servicesLoadStatus == 2)) {
                    if (this.distance != 250) {
                        if (this.$foundSomething == false) {
                            if (this.distance == 10) {
                                setTimeout(() => {
                                    if (this.services.length == 0) {
                                        this.$store.commit('setDistanceFilter', 20);
                                        EventBus.$emit('search-submitted', 20);
                                        //EventBus.$emit('distance-selected', 20);
                                        this.$map.setZoom(8);
                                    }
                                }, 2000);
                            } else if (this.distance == 20) {
                                setTimeout(() => {
                                    if (this.services.length == 0) {
                                        this.$store.commit('setDistanceFilter', 40);
                                        EventBus.$emit('search-submitted', 40);
                                        //EventBus.$emit('distance-selected', 40);
                                        this.$map.setZoom(8);
                                    }
                                }, 2000);
                            } else if (this.distance == 40) {
                                setTimeout(() => {
                                    if (this.services.length == 0) {
                                        this.$store.commit('setDistanceFilter', 60);
                                        EventBus.$emit('search-submitted', 60);
                                        //EventBus.$emit('distance-selected', 60);
                                        this.$map.setZoom(8);
                                    }
                                }, 2000);
                            } else {
                                setTimeout(() => {
                                    if (this.services.length == 0) {
                                        this.$store.commit('setDistanceFilter', 250);
                                        EventBus.$emit('search-submitted', 250);
                                        //EventBus.$emit('distance-selected', 250);
                                        this.$map.setZoom(8);
                                    }
                                }, 3000);
                            }
                        }
                    } else {
                        if (this.distance == 250) {
                            if (this.$foundSomething == false) {
                                setTimeout(() => {
                                    if (this.services.length == 0) {
                                        EventBus.$emit('info-modal');
                                    }
                                }, 3000);
                            }
                        }
                    }
                }

                this.clearMarkers();
                this.buildMarkers();

                if (this.$router.currentRoute.name != 'service') {
                    this.panToFirstService();
                }

                //this.processFilters();
            },

            activeLocationFilter() {
                this.processFilters();
            },
        },

        mounted() {
            this.$markers = [];
            this.$currentPositionMarker = null;
            this.$circle = null;

            this.$map = new google.maps.Map(document.getElementById('service-map'), {
                center: {lat: this.latitude, lng: this.longitude},
                zoom: this.zoom,
                streetViewControl: false,

                styles: [
                    {
                        stylers: [{
                            saturation: -100
                        }]
                    },
                    {
                        featureType: "poi",
                        stylers: [{
                            visibility: "off"
                        }]
                    }
                ],
                fullscreenControl: false,
                mapTypeControl: false
            });

            if (this.clientLocation) {
                this.$map.setCenter({
                    lat: this.clientLocation.latitude,
                    lng: this.clientLocation.longitude
                });

                this.$map.setZoom(12);

                this.buildCircle(this.distance, this.clientLocation.latitude, this.clientLocation.longitude);
            } else {
                this.locateCurrentPosition();
            }

            this.clearMarkers();
            this.buildMarkers();

            EventBus.$on('location-selected', function(service) {
                var latLng = new google.maps.LatLng(service.lat, service.lng);

                this.$map.setZoom(17);
                this.$map.panTo(latLng);
            }.bind(this));

            EventBus.$on('search-submitted', function(distance) {
                if (this.clientLocation.latitude && this.clientLocation.longitude) {
                    this.clearMarkers();

                    this.$store.dispatch('loadServices', {
                        distance: distance,
                        workroom: this.workroom,
                        makeId: this.makeId,
                        licensePlate: this.licensePlate,
                        latitude: this.clientLocation.latitude,
                        longitude: this.clientLocation.longitude
                    });

                    this.buildMarkers();

                    this.buildCircle(distance, this.clientLocation.latitude, this.clientLocation.longitude);

                    this.$map.setCenter({
                        lat: this.clientLocation.latitude,
                        lng: this.clientLocation.longitude
                    });

                    this.$map.setZoom(12);
                } else {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('general.blockedLocationServices') }, { root: true })
                }
            }.bind(this));

            EventBus.$on('type-switched', function() {
                if (this.clientLocation.latitude && this.clientLocation.longitude) {
                    this.clearMarkers();

                    this.$store.dispatch('loadServices', {
                        distance: this.distance,
                        workroom: this.workroom,
                        makeId: this.makeId,
                        licensePlate: this.licensePlate,
                        latitude: this.clientLocation.latitude,
                        longitude: this.clientLocation.longitude
                    });

                    this.buildMarkers();

                    this.buildCircle(this.distance, this.clientLocation.latitude, this.clientLocation.longitude);

                    this.$map.setCenter({
                        lat: this.clientLocation.latitude,
                        lng: this.clientLocation.longitude
                    });

                    this.$map.setZoom(12);
                } else {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('general.blockedLocationServices') }, { root: true })
                }
            }.bind(this));

            /*
            EventBus.$on('distance-selected', function(distance) {
                if (this.clientLocation.latitude && this.clientLocation.longitude) {
                    this.clearMarkers();

                    this.$store.dispatch('loadServices', {
                        distance: distance,
                        workroom: this.workroom,
                        makeId: this.makeId,
                        licensePlate: this.licensePlate,
                        latitude: this.clientLocation.latitude,
                        longitude: this.clientLocation.longitude
                    });

                    this.buildMarkers();
                    this.buildCircle(distance, this.clientLocation.latitude, this.clientLocation.longitude);
                } else {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('general.blockedLocationServices') }, { root: true })
                }
            }.bind(this));
            */

            /*
            EventBus.$on('address-entered', function(addressData) {
                this.clearMarkers();

                this.$store.dispatch('loadServices', {
                    distance: this.distance,
                    workroom: this.workroom,
                    makeId: this.makeId,
                    licensePlate: this.licensePlate,
                    latitude: addressData.latitude,
                    longitude: addressData.longitude
                });

                this.buildMarkers();

                this.$map.setCenter({
                    lat: addressData.latitude,
                    lng: addressData.longitude
                });

                this.$map.setZoom(12);

                this.buildCircle(this.distance, addressData.latitude, addressData.longitude);
            }.bind(this));
            */
        },

        methods: {
            locateCurrentPosition() {
                let serviceMap = this.$map;
                let self = this;

                const PRAGUE_LAT = 50.08804;
                const PRAGUE_LNG = 14.42076;

                if (!navigator.geolocation) {
                    console.log('Geolocation is not supported by this browser.');
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        Geocode.getCountryCodeFromPosition(position)
                            .then((response) => {
                                if (response != 'CZ') {
                                    serviceMap.setCenter({
                                        lat: PRAGUE_LAT,
                                        lng: PRAGUE_LNG
                                    });

                                    serviceMap.setZoom(12);
                                    self.buildCircle(self.distance, PRAGUE_LAT, PRAGUE_LNG);
                                } else {
                                    serviceMap.setCenter({
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude
                                    });

                                    serviceMap.setZoom(12);
                                    self.buildCircle(self.distance, position.coords.latitude, position.coords.longitude);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    },
                    function (error) {
                        console.log(error.message);
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 20000,
                        maximumAge: 300000
                    }
                );
            },

            buildCircle(radius, lat, lng) {
                var calculatedRadius = (radius * 1000);

                if (this.$currentPositionMarker) {
                    this.$currentPositionMarker.setMap(null);
                }

                var icon = {
                    url: '/img/person-marker-blue.svg',
                    scaledSize: new google.maps.Size(40, 40),
                }

                this.$currentPositionMarker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(lat),
                        lng: parseFloat(lng)
                    },
                    map: this.$map,
                    icon: icon,
                    animation: google.maps.Animation.BOUNCE,
                    //draggable: true,
                });

                /*
                currentPositionMarker.addListener('dragend', function() {
                    console.log('changed position manualy');
                });
                */

                if (this.$circle) {
                    this.$circle.setMap(null);
                }

                this.$circle = new google.maps.Circle({
                    map: this.$map,
                    radius: calculatedRadius,
                    fillColor: '#adadad',
                    strokeColor: '#c8017d',
                });

                this.$circle.bindTo('center', this.$currentPositionMarker, 'position');
            },

            buildMarkers() {
                this.$markers = [];

                for (var i = 0; i < this.services.length; i++) {
                    if (this.services[i].client_preference == 1) {
                        var image = {
                            url: '/img/service-blue-marker-big.svg',
                            scaledSize: new google.maps.Size(53, 75),
                        }
                        //var image = '/img/service-blue-marker-big.svg';
                    } else if (this.services[i].maintenance_slot == true && !this.makeId) {
                        var image = {
                            url: '/img/service-grass-green-marker-big.svg',
                            scaledSize: new google.maps.Size(40, 58),
                        }
                        //var image = '/img/service-grass-green-marker-big.svg';
                    } else {
                        if (this.workroom == 60) {
                            var image = {
                                url: '/img/tire-service-marker-big.svg',
                                scaledSize: new google.maps.Size(26, 37),
                            }
                        } else {
                            var image = {
                                url: '/img/service-middle-orange-marker-big.svg',
                                scaledSize: new google.maps.Size(26, 37),
                            }
                        }
                        //var image = '/img/service-middle-orange-marker-big.svg';
                    }

                    if (this.services[i].latitude != null ) {
                        var marker = new google.maps.Marker({
                            position: {
                                lat: parseFloat(this.services[i].latitude),
                                lng: parseFloat(this.services[i].longitude)
                            },
                            map: this.$map,
                            icon: image,
                            service: this.services[i]
                        });

                        let router = this.$router;
                        let store = this.$store;

                        marker.addListener('click', function() {
                            let center = this.map.getCenter();

                            store.dispatch('applyZoomLevel', this.map.getZoom());
                            store.dispatch('applyLat', center.lat());
                            store.dispatch('applyLng', center.lng());

                            router.push({ name: 'service', params: { slug: this.service.slug } });
                        });

                        this.$markers.push(marker);
                    }
                }
            },

            clearMarkers() {
                for (var i = 0; i < this.$markers.length; i++) {
                    this.$markers[i].setMap(null);
                }
            },

            panToFirstService() {
                if (this.services[0]) {
                    let center = this.$map.getCenter();

                    this.$store.dispatch('applyZoomLevel', this.$map.getZoom());
                    this.$store.dispatch('applyLat', center.lat());
                    this.$store.dispatch('applyLng', center.lng());

                    var panToLatLng = new google.maps.LatLng(this.services[0].latitude, this.services[0].longitude);

                    if (this.services.some(service => service.client_preference == 1)) {
                        this.services.forEach(service => {
                            if (service.client_preference == 1) {
                                panToLatLng = new google.maps.LatLng(service.latitude, service.longitude);

                                if (service.distance > this.distance) {
                                    this.$map.setZoom(8);
                                }
                            }
                        });
                    }

                    this.$map.panTo(panToLatLng);

                    /*
                    EventBus.$emit('location-selected', {
                        lat: parseFloat(this.services[0].latitude),
                        lng: parseFloat(this.services[0].longitude)
                    });
                    */

                    if (this.workroom == 860) {
                        this.$router.push({ name: 'service', params: { slug: this.services[0].slug } });
                    }

                    //this.$router.push({ name: 'service', params: { slug: this.services[0].slug } });
                }
            },

            processFilters() {
                for (var i = 0; i < this.$markers.length; i++) {
                    if (this.activeLocationFilter == 'all') {
                        this.$markers[i].setMap(this.$map);
                    } else {
                        var typePassed = false;

                        if (this.processServiceTypeFilter(this.$markers[i].service, this.activeLocationFilter)) {
                            typePassed = true;
                        }

                        if (typePassed) {
                            this.$markers[i].setMap(this.$map);
                        } else {
                            this.$markers[i].setMap(null);
                        }
                    }
                }
            },
        }
    }
</script>
